import { quoteSessionPresentation } from './quoteSessionPresentation.js'

// Shared presentation contract: moving the quote into the rail must not change
// the header's completed-session fallback, reference price or session colors.
export function equityHeadline(display) {
  const fallbackToRegular = display?.headlinePrice == null && display?.last != null
  const presentation = fallbackToRegular ? null : quoteSessionPresentation(display?.session)
  const price = (fallbackToRegular ? display.last : display?.headlinePrice) ?? null
  const reference = (fallbackToRegular ? display.regularReference : display?.headlineReference) ?? null
  const changePercent = (fallbackToRegular ? display.changePercent : display?.headlineChangePercent) ?? null
  const change = price != null && reference != null ? price - reference : null
  const isUp = change == null || change >= 0
  return { price, reference, change, changePercent, presentation, fallbackToRegular, isUp,
    colorClass: presentation?.textClass || (isUp ? 'text-forest' : 'text-ember') }
}
